// noinspection JSUnusedGlobalSymbols

import {FormStorage} from "../app/FormStorage";

require('jquery');
require('./ImageMarkerPoint');

export class ImageMarker
{
	element;

	/** @type {HTMLImageElement} */
	image;

	/** @type {HTMLImageElement[]} */
	stateImages;
	imagesLoaded;

	/** @type {HTMLInputElement} */
	input;

	ready;
	markerScale;

	/** @type {ImageMarkerPoint[]} */
	points;

	/** @type {HTMLCanvasElement} **/
	canvas;

	clicked;
	lossless;
	saveTimer;
	store;
	hitTestRadiusScale;

	constructor(element)
	{
		$(element).data('ImageMarker', this);

		let imageSource = element.dataset.image;

		let stateImageSources = (element.dataset.stateImages || '')
			.separate(';');

		let points = (element.dataset.points || '')
			.separate(';')
			.map((p) => p.splitToFloats());

		this.hitTestRadiusScale = 0.06;
		this.markerScale = parseFloat(element.dataset.markerScale || '1.0') || 1.0;
		this.element = element;
		this.lossless = false;
		this.canvas = element.querySelector('canvas');
		this.input = element.querySelector('input[type="hidden"]');
		this.imagesLoaded = 1 + stateImageSources.length;
		this.store = ('store' in this.element.dataset) || false;
		this.stateImages = stateImageSources.map((src) =>
		{
			let image = new Image();
			image.onload = () => { this.onImageLoaded(); };
			image.src = src;
			return image;
		});
		this.image = new Image();
		this.image.onload = () => { this.onImageLoaded(); };
		this.image.src = imageSource;
		this.points = points.map((p) => new ImageMarkerPoint(p[0], p[1]));
		this.clicked = [];
		this.saveTimer = null;

		this.canvas.addEventListener('click', (e) => this.onCanvasClick(e));

		this.restoreIfEnabled();
	}

	onImageLoaded()
	{
		if (--this.imagesLoaded > 0)
			return;

		this.canvas.width = this.image.width;
		this.canvas.height = this.image.height;
		this.element.style.aspectRatio = this.image.width / this.image.height;
		this.ready = true;
		this.draw();
	}

	draw()
	{
		if (!this.ready)
			return;

		if (this.saveTimer)
			clearTimeout(this.saveTimer);

		let ctx = this.canvas.getContext('2d');
		let w = this.canvas.width;
		let h = this.canvas.height;

		ctx.fillStyle = 'white';
		ctx.fillRect(0, 0, w, h);
		ctx.drawImage(this.image, 0, 0, w, h);

		this.points.forEach((p) => this.drawPoint(ctx, p));

		this.saveToInput();
	}

	saveToInput()
	{
		this.storeIfEnabled();
		this.saveTimer = setTimeout(() =>
		{
			this.input.value = this.lossless ? this.pngData() : this.jpegData();
			this.saveTimer = null;
		}, 250);
	}

	/**
	 * @param {CanvasRenderingContext2D} ctx
	 * @param {ImageMarkerPoint} p
	 */
	drawPoint(ctx, p)
	{
		let image = this.stateImages[p.state % this.stateImages.length];
		let w = image.width * this.markerScale;
		let h = image.height * this.markerScale;
		let x = p.x - (w * 0.5);
		let y = p.y - (h * 0.5);

		ctx.drawImage(image, x, y, w, h);

		if (App.isProduction)
		{
			let radius = this.hitTestRadiusScale * this.image.width;
			ctx.beginPath();
			ctx.arc(p.x, p.y, radius, 0, Math.PI * 2);
			ctx.strokeStyle = 'blue';
			ctx.stroke();
		}
	}

	onCanvasClick(e)
	{
		if (!this.ready || e.which !== 1)
			return;

		this.click(e.offsetX, e.offsetY);
	}

	click(x, y)
	{
		let w = this.canvas.clientWidth;
		let h = this.canvas.clientHeight;
		let cx = (x / w) * this.image.width;
		let cy = (y / h) * this.image.height;
		let radius = this.hitTestRadiusScale * this.image.width;
		this.clicked.push([Math.floor(cx * this.image.width),Math.floor(cy * this.image.height)]);

		let hit = this.points.filter((p) => p.hitTest(cx, cy, radius));
		if (hit.length === 0)
			return;

		let point = hit[0];
		point.state++;
		if (point.state >= this.stateImages.length)
			point.state = 0;

		this.draw();
	}

	pngData()
	{
		return this.canvas.toDataURL('image/png');
	}

	jpegData(quality)
	{
		return this.canvas.toDataURL('image/jpeg', quality || 0.9);
	}

	static enumerate()
	{
		$('.x-image-marker').each((i, elem) =>
		{
			let self = $(elem);
			if (self.data('ImageMarker'))
				return;

			(new ImageMarker(elem));
		});
	}

	storeIfEnabled()
	{
		if (!this.store)
			return;

		FormStorage.set(FormStorage.keyFor(this.input), JSON.stringify(this.points));
	}

	restoreIfEnabled()
	{
		if (!this.store)
			return;

		let value = FormStorage.get(FormStorage.keyFor(this.input));
		if (value !== null)
		{
			let data = JSON.parse(value);
			if (Array.isArray(data))
			{
				this.points = data.map((p) => new ImageMarkerPoint(p.x, p.y, p.state));
				this.draw();
			}
		}
	}
}

window.ImageMarker = ImageMarker;

$(ImageMarker.enumerate);
